import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { StorageSessionHelper } from '@helpers/storage-session.helper';
import { StorageHelper } from '@helpers/storage.helper';
import { CacheService } from '@services/cache.service';
import { EventBusService } from '@services/event-bus.service';
import { AuthService } from './auth/services/auth.service';
import { MenuService } from '@security/services/menu.service';
import { LoggerService } from '@services/logger.service';
import { LOCKBIN_BUS_EVENT_TYPE, LOCKBIN_STORAGE_KEY } from '@core/enums';

@Component({
  selector: 'lockbin-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  standalone: false,
})
export class AppComponent {
  title = 'lockbin-backend-portal';
  currentUrl: string | undefined;

  constructor(
    private logger: LoggerService,
    private router: Router,
    private eventBusService: EventBusService,
    private cacheService: CacheService<any>,
    private authService: AuthService,
    private menuService: MenuService,
  ) {
    this.logger.debug('Iniciando desde AppComponent constructor');

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.urlAfterRedirects;
        this.logger.debug(event); // Para depurar, ver el objeto completo de NavigationEnd
      }
    });

    // Proceso cuando se hace logout
    this.eventBusService.on('lockbin.logout', () => {
      this.authService.signout().subscribe({ error: () => {} });

      StorageHelper.removeItem(LOCKBIN_STORAGE_KEY.SETUP_CONFIGURATION_PROFILE);

      StorageSessionHelper.clearSessionStorage();

      this.cacheService.clear();
    });

    this.eventBusService.on(LOCKBIN_BUS_EVENT_TYPE.REGIONS_CHANGED, () => {
      StorageSessionHelper.removeItem(LOCKBIN_STORAGE_KEY.SESSION_CITIES);
    });

    this.eventBusService.on(LOCKBIN_BUS_EVENT_TYPE.CITIES_CHANGED, () => {
      StorageSessionHelper.removeItem(LOCKBIN_STORAGE_KEY.SESSION_CITIES);
    });

    this.eventBusService.on(LOCKBIN_BUS_EVENT_TYPE.COUNTRIES_CHANGED, () => {
      StorageSessionHelper.removeItem(LOCKBIN_STORAGE_KEY.SESSION_CITIES);
    });

    this.eventBusService.on(LOCKBIN_BUS_EVENT_TYPE.EQUIPMENT_GROUP_CHANGED, () => {
      StorageSessionHelper.removeItem(LOCKBIN_STORAGE_KEY.SESSION_ZONES);
      StorageSessionHelper.removeItem(LOCKBIN_STORAGE_KEY.SESSION_POSTALCODES);
      StorageSessionHelper.removeItem(LOCKBIN_STORAGE_KEY.SESSION_GROUP_TYPES);
    });

    this.eventBusService.on(LOCKBIN_BUS_EVENT_TYPE.BROKERS_CHANGED, () => {
      StorageSessionHelper.removeItem(LOCKBIN_STORAGE_KEY.SESSION_BROKERS);
    });

    if (this.authService.isLogged()) {
      // Obtenemos el menú segun el Rol
      const role = this.authService.getRole();
      if (role) {
        this.menuService.setMenuStructureForRoles(role, this.authService.getCustomer(), this.authService.getUser());
      }
    }
  }
}
